'use client';

import Lightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Slideshow from 'yet-another-react-lightbox/plugins/slideshow';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';

export type ProjectWorkShowcaseLightboxSlide = {
    src: string;
    alt?: string;
    title?: string;
    description?: string;
    width?: number;
    height?: number;
};

export default function ProjectWorkShowcaseLightbox({
    slides,
    activeImageIndex,
    lightboxLabel,
    onClose,
}: {
    slides: ProjectWorkShowcaseLightboxSlide[];
    activeImageIndex: number;
    lightboxLabel: string;
    onClose: () => void;
}) {
    return (
        <Lightbox
            slides={slides}
            open={activeImageIndex >= 0 && activeImageIndex < slides.length}
            index={activeImageIndex}
            close={onClose}
            plugins={[Captions, Fullscreen, Slideshow, Zoom]}
            captions={{ showToggle: false, descriptionTextAlign: 'start', descriptionMaxLines: 4 }}
            carousel={{ finite: slides.length <= 1 }}
            controller={{ aria: true }}
            className="project-work-showcase-lightbox"
            labels={{ Slide: lightboxLabel, Caption: 'Image caption' }}
        />
    );
}
